import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ScrollService } from '../../services/Scroll/scroll.service';
import { Company, typeInterface } from '../../Interfaces/company';
import { ConnectionService } from '../../services/Connection/connection.service';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-min-value',
  templateUrl: './min-value.component.html',
  styleUrl: './min-value.component.css'
})
export class MinValueComponent implements OnChanges{
  @ViewChild('offCanva') offCanva!: ElementRef
  @Input() openInfoMinValue = false;
  @Input() company!: Company;
  @Output() closeCanvas : EventEmitter<boolean> = new EventEmitter<boolean>();
  typeParam!: typeInterface;
  nameCompany: string = '';
  offCanvasHeight: string | number = 'auto';
  initHeight: number = 0;
  private startY = 0;
  private isDragging = false;

  constructor(public scrollService: ScrollService, private connection: ConnectionService, private router: Router){
    this.connection.typeParam$.subscribe((data) =>{
      this.typeParam = data;
    })
    this.connection.nameCompany$.subscribe((data) =>{
      this.nameCompany = data;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['openInfoMinValue'].currentValue == true){
      this.openCanva();
    }
  }

  //Abre o offcanva
  openCanva(){
    this.offCanvasHeight = this.offCanva.nativeElement.offsetHeight;
    this.initHeight = Number(this.offCanvasHeight)
    this.scrollService.disableScroll();
  }

  //Quando o usuario clica
  onTouchStart(event: TouchEvent) {
    this.startY = event.touches[0].clientY;
    this.isDragging = true;
  }

  // Quando o usuario arrasta
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;

    const currentY = event.touches[0].clientY;
    const deltaY = currentY - this.startY;

    if (deltaY > 0) {
      this.offCanvasHeight = Math.max(0, this.initHeight - deltaY);
    }
  }

  // Finalizar o toque
  onTouchEnd() {
    this.isDragging = false;

    // Fechar se a altura for pequena
    if (Number(this.offCanvasHeight) < 50) {
      this.closeOffCanvas();
    } else {
      this.offCanvasHeight = this.initHeight; // Resetar altura
    }
  }

  // Fechar o OffCanvas
  closeOffCanvas() {
    this.openInfoMinValue = false;
    this.offCanvasHeight = this.initHeight;
    this.closeCanvas.emit(false);

    setTimeout(() => {
      this.scrollService.enableScroll();
    }, 500);
  }

  //Navega até o cardápio
  addItem(){
    this.scrollService.enableScroll();
    if(this.typeParam.type == 3)
    {
      this.router.navigate([this.nameCompany, 'B']);
    }
    else{
      this.router.navigate([this.nameCompany]);
    }
  }
}
